/**
 * When to show the wait cursor.
 *
 * A job under about 120ms stays on the current cursor so a fast edit does not
 * flash the hourglass. Larger jobs set `cursor: wait` and let the browser
 * paint it before the work runs.
 *
 * Measured after erase stopped rebuilding the whole graph on every hit
 * (5,041 points, 9,940 lines, 80 lines erased): the stroke was 7.6ms total
 * and releasing the pointer was 17ms. Fill Roads weld was ~102ms at 400
 * lines and ~194ms at 600. Deleting about 12,000 features was ~70ms.
 */

/** Past this, the main thread is busy long enough to show the wait cursor. */
export const WAIT_CURSOR_MS = 120;

/**
 * Short centerlines: 400 lines ~102ms, 600 lines ~194ms.
 * Longer lines: 1,600 vertices ~83ms, 3,200 vertices ~232ms.
 */
export function fillIsHeavy(lineCount: number, vertices: number): boolean {
  return lineCount >= 450 || vertices >= 2_800;
}

/**
 * A draft diff that removes this many features can pass {@link WAIT_CURSOR_MS}.
 * Point deletes fan out into the lines that touched them.
 */
export function deleteIsHeavy(segmentCount: number, droppingPoints: number, droppingLines: number): boolean {
  const estimated =
    droppingPoints > 0 ? Math.min(segmentCount, droppingPoints * 3 + droppingLines) : droppingLines;
  return estimated >= 16_000;
}

/** One compact at the end of a stroke. Tens of thousands of lines can still stall. */
export function eraseCommitIsHeavy(removedSegments: number): boolean {
  return removedSegments >= 16_000;
}

/**
 * Reading every road in a work area hits the map tiles. How long that takes
 * is not known until the query runs, and a city block can exceed
 * {@link WAIT_CURSOR_MS}.
 */
export function roadExtractIsHeavy(): boolean {
  return true;
}
